import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import React from 'react';
import { MyMVariantLabel } from '../../ui-elements/MyMLabel';
import { MyMLink } from '../../ui-elements/MyMLink';
import { ItAppLinkCard } from '../../ui-parts/ItAppLinkCard';

/**
 * UserProfile Favorite IT Apps Component
 */
const UserProfileFavoriteItApps = React.memo(({ screenId, apiRequest, controlSettings, favoriteItApp, setFavoriteItApp, setIsLoading }) => {

  // お気に入りITApps一覧コンポーネント
  const UserProfileMyFavoriteApplicationList = () => {

    // Removeボタン押下時イベント
    const RemoveFavoriteApplicationButtonHandler = (key) => {
      const param = {
        Key: key,
        UnFavorite: true,
      };

      const callbackSuccess = () => {
        setFavoriteItApp([
          ...favoriteItApp.filter(item => item.ItAppId !== key),
          { ItAppId: null, ItAppLink: null, ItAppNameAbb: null, ItAppNameOfficial: null, LogoEncodeBase64Data: null, logoFileExtension: null }
        ]);
        setIsLoading(false);
      }

      const callbackFailed = () => setIsLoading(false);

      setIsLoading(true);
      apiRequest.requestJson('api/it-applications/favorite', 'POST', callbackSuccess, callbackFailed, param);
    };

    return (
      <List sx={{ padding: 0, mt: 0.5 }}>
        {favoriteItApp.map((item, index) =>
          <ListItem key={index} className='d-flex align-items-center ' mb={1} sx={{ minWidth: '320px' }} >
            <Box p={"2px"} sx={{ minWidth: "180px", }}>
              <ItAppLinkCard
                screenId={screenId}
                nameAbb={item.ItAppNameAbb}
                nameOfficial={item.ItAppNameOfficial}
                link={item.ItAppLink}
                logoEncodeBase64Data={item.LogoEncodeBase64Data}
                logoFileExtension={item.LogoFileExtension}
                controlSettings={controlSettings}
                baseColor='#999'
                apiRequest={apiRequest}
                itAppId={item.ItAppId}
              />
            </Box>
            <MyMLink underline="hover" sx={{ color: '#fff', whitespace: "nowrap", visibility: item.ItAppId === null ? "hidden" : "unset" }} onClick={() => { RemoveFavoriteApplicationButtonHandler(item.ItAppId) }}>{controlSettings.LabelList.lnkRemove}</MyMLink>
          </ListItem>
        )}
      </List>
    )
  }

  return (
    <Grid item xs={12} md={12} lg={3}>
      <Box className='profile-content' >
        <TableContainer >
          <Table sx={{ border: 0, '&:last-child td, &:last-child th': { border: 0 } }}>
            <TableHead>
              <TableRow>
                <TableCell variant='head'>
                  <MyMVariantLabel variant='h5'>{controlSettings.LabelList.lblMyFavoriteApps}</MyMVariantLabel>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className='profile-content-body'>
              <TableRow>
                <TableCell variant='head' sx={{ padding: "0px" }}>
                  <UserProfileMyFavoriteApplicationList />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Grid>
  );
})
export default UserProfileFavoriteItApps;
